module.exports = __webpack_public_path__ + "ccc2042299ff87ab7efdc2a13d17b300.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/img1_2.jpg
// module id = 342
// module chunks = 0